const data = [
  { date: '01/05/2009', 'Number of comments': 1, amount: 100 },
  { date: '02/16/2009', 'Number of comments': 2, amount: 100 },
  { date: '03/23/2009', 'Number of comments': 1, amount: 100 },
  { date: '04/13/2009', 'Number of comments': 1, amount: 100 },
  { date: '05/04/2009', 'Number of comments': 1, amount: 100 },
  { date: '06/01/2009', 'Number of comments': 1, amount: 100 },
  { date: '06/21/2010', 'Number of comments': 1, amount: 100 },
  { date: '08/30/2010', 'Number of comments': 5, amount: 100 },
  { date: '09/06/2010', 'Number of comments': 5, amount: 100 },
  { date: '09/13/2010', 'Number of comments': 6, amount: 100 },
  { date: '09/20/2010', 'Number of comments': 2, amount: 100 },
  { date: '09/27/2010', 'Number of comments': 9, amount: 100 },
  { date: '10/04/2010', 'Number of comments': 5, amount: 100 },
  { date: '10/11/2010', 'Number of comments': 3, amount: 100 },
  { date: '10/18/2010', 'Number of comments': 4, amount: 100 },
  { date: '10/25/2010', 'Number of comments': 2, amount: 100 },
  { date: '11/01/2010', 'Number of comments': 1, amount: 100 },
  { date: '11/08/2010', 'Number of comments': 6, amount: 100 },
  { date: '11/15/2010', 'Number of comments': 4, amount: 100 },
  { date: '11/22/2010', 'Number of comments': 2, amount: 100 },
  { date: '11/29/2010', 'Number of comments': 3, amount: 100 },
  { date: '12/06/2010', 'Number of comments': 7, amount: 100 },
  { date: '12/13/2010', 'Number of comments': 1, amount: 100 },
  { date: '12/27/2010', 'Number of comments': 2, amount: 100 },
  { date: '01/03/2011', 'Number of comments': 3, amount: 100 },
  { date: '01/17/2011', 'Number of comments': 2, amount: 100 },
  { date: '01/24/2011', 'Number of comments': 3, amount: 100 },
  { date: '01/31/2011', 'Number of comments': 3, amount: 100 },
  { date: '02/07/2011', 'Number of comments': 2, amount: 100 },
  { date: '02/14/2011', 'Number of comments': 10, amount: 100 },
  { date: '02/21/2011', 'Number of comments': 8, amount: 100 },
  { date: '02/28/2011', 'Number of comments': 3, amount: 100 },
  { date: '03/07/2011', 'Number of comments': 9, amount: 100 },
  { date: '03/14/2011', 'Number of comments': 6, amount: 100 },
  { date: '03/21/2011', 'Number of comments': 7, amount: 100 },
  { date: '03/28/2011', 'Number of comments': 6, amount: 100 },
  { date: '04/04/2011', 'Number of comments': 4, amount: 100 },
  { date: '04/11/2011', 'Number of comments': 8, amount: 100 },
  { date: '04/18/2011', 'Number of comments': 7, amount: 100 },
  { date: '04/25/2011', 'Number of comments': 12, amount: 100 },
  { date: '05/02/2011', 'Number of comments': 19, amount: 100 },
  { date: '05/09/2011', 'Number of comments': 16, amount: 100 },
  { date: '05/16/2011', 'Number of comments': 12, amount: 100 },
  { date: '05/23/2011', 'Number of comments': 9, amount: 100 },
  { date: '05/30/2011', 'Number of comments': 6, amount: 100 },
  { date: '06/06/2011', 'Number of comments': 11, amount: 100 },
  { date: '06/13/2011', 'Number of comments': 15, amount: 100 },
  { date: '06/20/2011', 'Number of comments': 18, amount: 100 },
  { date: '06/27/2011', 'Number of comments': 9, amount: 100 },
  { date: '07/04/2011', 'Number of comments': 14, amount: 100 },
  { date: '07/11/2011', 'Number of comments': 5, amount: 100 },
  { date: '07/18/2011', 'Number of comments': 13, amount: 100 },
  { date: '07/25/2011', 'Number of comments': 19, amount: 100 },
  { date: '08/01/2011', 'Number of comments': 30, amount: 100 },
  { date: '08/08/2011', 'Number of comments': 20, amount: 100 },
  { date: '08/15/2011', 'Number of comments': 9, amount: 100 },
  { date: '08/22/2011', 'Number of comments': 56, amount: 100 },
  { date: '08/29/2011', 'Number of comments': 117, amount: 100 },
  { date: '09/05/2011', 'Number of comments': 35, amount: 100 },
  { date: '09/12/2011', 'Number of comments': 54, amount: 100 },
  { date: '09/19/2011', 'Number of comments': 48, amount: 100 },
  { date: '09/26/2011', 'Number of comments': 66, amount: 100 },
  { date: '10/03/2011', 'Number of comments': 55, amount: 100 },
  { date: '10/10/2011', 'Number of comments': 56, amount: 100 },
  { date: '10/17/2011', 'Number of comments': 95, amount: 100 },
  { date: '10/24/2011', 'Number of comments': 80, amount: 100 },
  { date: '10/31/2011', 'Number of comments': 98, amount: 100 },
  { date: '11/07/2011', 'Number of comments': 140, amount: 100 },
  { date: '11/14/2011', 'Number of comments': 147, amount: 100 },
  { date: '11/21/2011', 'Number of comments': 35, amount: 100 },
  { date: '11/28/2011', 'Number of comments': 62, amount: 100 },
  { date: '12/05/2011', 'Number of comments': 64, amount: 100 },
  { date: '12/12/2011', 'Number of comments': 62, amount: 100 },
  { date: '12/19/2011', 'Number of comments': 38, amount: 100 },
  { date: '12/26/2011', 'Number of comments': 34, amount: 100 },
  { date: '01/02/2012', 'Number of comments': 37, amount: 100 },
  { date: '01/09/2012', 'Number of comments': 47, amount: 100 },
  { date: '01/16/2012', 'Number of comments': 56, amount: 100 },
  { date: '01/23/2012', 'Number of comments': 58, amount: 100 },
  { date: '01/30/2012', 'Number of comments': 63, amount: 100 },
  { date: '02/06/2012', 'Number of comments': 46, amount: 100 },
  { date: '02/13/2012', 'Number of comments': 48, amount: 100 },
  { date: '02/20/2012', 'Number of comments': 61, amount: 100 },
  { date: '02/27/2012', 'Number of comments': 70, amount: 100 },
  { date: '03/05/2012', 'Number of comments': 59, amount: 100 },
  { date: '03/12/2012', 'Number of comments': 64, amount: 100 },
  { date: '03/19/2012', 'Number of comments': 70, amount: 100 },
  { date: '03/26/2012', 'Number of comments': 42, amount: 100 },
  { date: '04/02/2012', 'Number of comments': 73, amount: 100 },
  { date: '04/09/2012', 'Number of comments': 83, amount: 100 },
  { date: '04/16/2012', 'Number of comments': 125, amount: 100 },
  { date: '04/23/2012', 'Number of comments': 81, amount: 100 },
  { date: '04/30/2012', 'Number of comments': 67, amount: 100 },
  { date: '05/07/2012', 'Number of comments': 99, amount: 100 },
  { date: '05/14/2012', 'Number of comments': 52, amount: 100 },
  { date: '05/21/2012', 'Number of comments': 56, amount: 100 },
  { date: '05/28/2012', 'Number of comments': 58, amount: 100 },
  { date: '06/04/2012', 'Number of comments': 49, amount: 100 },
  { date: '06/11/2012', 'Number of comments': 50, amount: 100 },
  { date: '06/18/2012', 'Number of comments': 55, amount: 100 },
  { date: '06/25/2012', 'Number of comments': 43, amount: 100 },
  { date: '07/02/2012', 'Number of comments': 41, amount: 100 },
  { date: '07/09/2012', 'Number of comments': 54, amount: 100 },
  { date: '07/16/2012', 'Number of comments': 72, amount: 100 },
  { date: '07/23/2012', 'Number of comments': 68, amount: 100 },
  { date: '07/30/2012', 'Number of comments': 70, amount: 100 },
  { date: '08/06/2012', 'Number of comments': 62, amount: 100 },
  { date: '08/13/2012', 'Number of comments': 57, amount: 100 },
  { date: '08/20/2012', 'Number of comments': 77, amount: 100 },
  { date: '08/27/2012', 'Number of comments': 88, amount: 100 },
  { date: '09/03/2012', 'Number of comments': 72, amount: 100 },
  { date: '09/10/2012', 'Number of comments': 66, amount: 100 },
  { date: '09/17/2012', 'Number of comments': 67, amount: 100 },
  { date: '09/24/2012', 'Number of comments': 78, amount: 100 },
  { date: '10/01/2012', 'Number of comments': 77, amount: 100 },
  { date: '10/08/2012', 'Number of comments': 64, amount: 100 },
  { date: '10/15/2012', 'Number of comments': 81, amount: 100 },
  { date: '10/22/2012', 'Number of comments': 63, amount: 100 },
  { date: '10/29/2012', 'Number of comments': 67, amount: 100 },
  { date: '11/05/2012', 'Number of comments': 56, amount: 100 },
  { date: '11/12/2012', 'Number of comments': 45, amount: 100 },
  { date: '11/19/2012', 'Number of comments': 62, amount: 100 },
  { date: '11/26/2012', 'Number of comments': 66, amount: 100 },
  { date: '12/03/2012', 'Number of comments': 83, amount: 100 },
  { date: '12/10/2012', 'Number of comments': 56, amount: 100 },
  { date: '12/17/2012', 'Number of comments': 26, amount: 100 },
  { date: '12/24/2012', 'Number of comments': 21, amount: 100 },
  { date: '12/31/2012', 'Number of comments': 2, amount: 100 },
  { date: '12/30/2013', 'Number of comments': 18, amount: 100 },
  { date: '01/06/2014', 'Number of comments': 26, amount: 100 },
  { date: '01/13/2014', 'Number of comments': 39, amount: 100 },
  { date: '01/20/2014', 'Number of comments': 47, amount: 100 },
  { date: '01/27/2014', 'Number of comments': 28, amount: 100 },
  { date: '02/03/2014', 'Number of comments': 35, amount: 100 },
  { date: '02/10/2014', 'Number of comments': 33, amount: 100 },
  { date: '02/17/2014', 'Number of comments': 22, amount: 100 },
  { date: '02/24/2014', 'Number of comments': 34, amount: 100 },
  { date: '03/03/2014', 'Number of comments': 28, amount: 100 },
  { date: '03/10/2014', 'Number of comments': 27, amount: 100 },
  { date: '03/17/2014', 'Number of comments': 31, amount: 100 },
  { date: '03/24/2014', 'Number of comments': 38, amount: 100 },
  { date: '03/31/2014', 'Number of comments': 35, amount: 100 },
  { date: '04/07/2014', 'Number of comments': 55, amount: 100 },
  { date: '04/14/2014', 'Number of comments': 37, amount: 100 },
  { date: '04/21/2014', 'Number of comments': 42, amount: 100 },
  { date: '04/28/2014', 'Number of comments': 48, amount: 100 },
  { date: '05/05/2014', 'Number of comments': 38, amount: 100 },
  { date: '05/12/2014', 'Number of comments': 39, amount: 100 },
  { date: '05/19/2014', 'Number of comments': 30, amount: 100 },
  { date: '05/26/2014', 'Number of comments': 17, amount: 100 },
  { date: '06/02/2014', 'Number of comments': 17, amount: 100 },
  { date: '06/09/2014', 'Number of comments': 13, amount: 100 },
  { date: '06/16/2014', 'Number of comments': 22, amount: 100 },
  { date: '06/23/2014', 'Number of comments': 28, amount: 100 },
  { date: '06/30/2014', 'Number of comments': 29, amount: 100 },
  { date: '07/07/2014', 'Number of comments': 26, amount: 100 },
  { date: '07/14/2014', 'Number of comments': 24, amount: 100 },
  { date: '07/21/2014', 'Number of comments': 20, amount: 100 },
  { date: '07/28/2014', 'Number of comments': 27, amount: 100 },
  { date: '08/04/2014', 'Number of comments': 30, amount: 100 },
  { date: '08/11/2014', 'Number of comments': 31, amount: 100 },
  { date: '08/18/2014', 'Number of comments': 32, amount: 100 },
  { date: '08/25/2014', 'Number of comments': 41, amount: 100 },
  { date: '09/01/2014', 'Number of comments': 27, amount: 100 },
  { date: '09/08/2014', 'Number of comments': 36, amount: 100 },
  { date: '09/15/2014', 'Number of comments': 35, amount: 100 },
  { date: '09/22/2014', 'Number of comments': 28, amount: 100 },
  { date: '09/29/2014', 'Number of comments': 37, amount: 100 },
  { date: '10/06/2014', 'Number of comments': 31, amount: 100 },
  { date: '10/13/2014', 'Number of comments': 30, amount: 100 },
  { date: '10/20/2014', 'Number of comments': 29, amount: 100 },
  { date: '10/27/2014', 'Number of comments': 28, amount: 100 },
  { date: '11/03/2014', 'Number of comments': 27, amount: 100 },
  { date: '11/10/2014', 'Number of comments': 24, amount: 100 },
  { date: '11/17/2014', 'Number of comments': 48, amount: 100 },
  { date: '11/24/2014', 'Number of comments': 31, amount: 100 },
  { date: '12/01/2014', 'Number of comments': 46, amount: 100 },
  { date: '12/08/2014', 'Number of comments': 64, amount: 100 },
  { date: '12/15/2014', 'Number of comments': 32, amount: 100 },
  { date: '12/22/2014', 'Number of comments': 21, amount: 100 },
  { date: '12/29/2014', 'Number of comments': 38, amount: 100 },
  { date: '01/05/2015', 'Number of comments': 50, amount: 100 },
  { date: '01/12/2015', 'Number of comments': 75, amount: 100 },
  { date: '01/19/2015', 'Number of comments': 99, amount: 100 },
  { date: '01/26/2015', 'Number of comments': 86, amount: 100 },
  { date: '02/02/2015', 'Number of comments': 67, amount: 100 },
  { date: '02/09/2015', 'Number of comments': 58, amount: 100 },
  { date: '02/16/2015', 'Number of comments': 49, amount: 100 },
  { date: '02/23/2015', 'Number of comments': 84, amount: 100 },
  { date: '03/02/2015', 'Number of comments': 65, amount: 100 },
  { date: '03/09/2015', 'Number of comments': 76, amount: 100 },
  { date: '03/16/2015', 'Number of comments': 71, amount: 100 },
  { date: '03/23/2015', 'Number of comments': 65, amount: 100 },
  { date: '03/30/2015', 'Number of comments': 92, amount: 100 },
  { date: '04/06/2015', 'Number of comments': 91, amount: 100 },
  { date: '04/13/2015', 'Number of comments': 115, amount: 100 },
  { date: '04/20/2015', 'Number of comments': 134, amount: 100 },
  { date: '04/27/2015', 'Number of comments': 99, amount: 100 },
  { date: '05/04/2015', 'Number of comments': 114, amount: 100 },
  { date: '05/11/2015', 'Number of comments': 104, amount: 100 },
  { date: '05/18/2015', 'Number of comments': 80, amount: 100 },
  { date: '05/25/2015', 'Number of comments': 70, amount: 100 },
  { date: '06/01/2015', 'Number of comments': 79, amount: 100 },
  { date: '06/08/2015', 'Number of comments': 81, amount: 100 },
  { date: '06/15/2015', 'Number of comments': 74, amount: 100 },
  { date: '06/22/2015', 'Number of comments': 79, amount: 100 },
  { date: '06/29/2015', 'Number of comments': 76, amount: 100 },
  { date: '07/06/2015', 'Number of comments': 102, amount: 100 },
  { date: '07/13/2015', 'Number of comments': 107, amount: 100 },
  { date: '07/20/2015', 'Number of comments': 87, amount: 100 },
  { date: '07/27/2015', 'Number of comments': 97, amount: 100 },
  { date: '08/03/2015', 'Number of comments': 106, amount: 100 },
  { date: '08/10/2015', 'Number of comments': 114, amount: 100 },
  { date: '08/17/2015', 'Number of comments': 141, amount: 100 },
  { date: '08/24/2015', 'Number of comments': 148, amount: 100 },
  { date: '08/31/2015', 'Number of comments': 126, amount: 100 },
  { date: '09/07/2015', 'Number of comments': 137, amount: 100 },
  { date: '09/14/2015', 'Number of comments': 121, amount: 100 },
  { date: '09/21/2015', 'Number of comments': 126, amount: 100 },
  { date: '09/28/2015', 'Number of comments': 103, amount: 100 },
  { date: '10/05/2015', 'Number of comments': 121, amount: 100 },
  { date: '10/12/2015', 'Number of comments': 115, amount: 100 },
  { date: '10/19/2015', 'Number of comments': 156, amount: 100 },
  { date: '10/26/2015', 'Number of comments': 148, amount: 100 },
  { date: '11/02/2015', 'Number of comments': 91, amount: 100 },
  { date: '11/09/2015', 'Number of comments': 84, amount: 100 },
  { date: '11/16/2015', 'Number of comments': 119, amount: 100 },
  { date: '11/23/2015', 'Number of comments': 85, amount: 100 },
  { date: '11/30/2015', 'Number of comments': 79, amount: 100 },
  { date: '12/07/2015', 'Number of comments': 88, amount: 100 },
  { date: '12/14/2015', 'Number of comments': 86, amount: 100 },
  { date: '12/21/2015', 'Number of comments': 70, amount: 100 },
  { date: '12/28/2015', 'Number of comments': 59, amount: 100 },
  { date: '01/04/2016', 'Number of comments': 79, amount: 100 },
  { date: '01/11/2016', 'Number of comments': 90, amount: 100 },
  { date: '01/18/2016', 'Number of comments': 114, amount: 100 },
  { date: '01/25/2016', 'Number of comments': 78, amount: 100 },
  { date: '02/01/2016', 'Number of comments': 91, amount: 100 },
  { date: '02/08/2016', 'Number of comments': 96, amount: 100 },
  { date: '02/15/2016', 'Number of comments': 96, amount: 100 },
  { date: '02/22/2016', 'Number of comments': 115, amount: 100 },
  { date: '02/29/2016', 'Number of comments': 101, amount: 100 },
  { date: '03/07/2016', 'Number of comments': 88, amount: 100 },
  { date: '03/14/2016', 'Number of comments': 87, amount: 100 },
  { date: '03/21/2016', 'Number of comments': 88, amount: 100 },
  { date: '03/28/2016', 'Number of comments': 121, amount: 100 },
  { date: '04/04/2016', 'Number of comments': 109, amount: 100 },
  { date: '04/11/2016', 'Number of comments': 98, amount: 100 },
  { date: '04/18/2016', 'Number of comments': 120, amount: 100 },
  { date: '04/25/2016', 'Number of comments': 107, amount: 100 },
  { date: '05/02/2016', 'Number of comments': 105, amount: 100 },
  { date: '05/09/2016', 'Number of comments': 91, amount: 100 },
  { date: '05/16/2016', 'Number of comments': 87, amount: 100 },
  { date: '05/23/2016', 'Number of comments': 59, amount: 100 },
  { date: '05/30/2016', 'Number of comments': 91, amount: 100 },
  { date: '06/06/2016', 'Number of comments': 77, amount: 100 },
  { date: '06/13/2016', 'Number of comments': 80, amount: 100 },
  { date: '06/20/2016', 'Number of comments': 77, amount: 100 },
  { date: '06/27/2016', 'Number of comments': 73, amount: 100 },
  { date: '07/04/2016', 'Number of comments': 74, amount: 100 },
  { date: '07/11/2016', 'Number of comments': 66, amount: 100 },
  { date: '07/18/2016', 'Number of comments': 66, amount: 100 },
  { date: '07/25/2016', 'Number of comments': 89, amount: 100 },
  { date: '08/01/2016', 'Number of comments': 105, amount: 100 },
  { date: '08/08/2016', 'Number of comments': 109, amount: 100 },
  { date: '08/15/2016', 'Number of comments': 136, amount: 100 },
  { date: '08/22/2016', 'Number of comments': 138, amount: 100 },
  { date: '08/29/2016', 'Number of comments': 105, amount: 100 },
  { date: '09/05/2016', 'Number of comments': 110, amount: 100 },
  { date: '09/12/2016', 'Number of comments': 97, amount: 100 },
  { date: '09/19/2016', 'Number of comments': 99, amount: 100 },
  { date: '09/26/2016', 'Number of comments': 87, amount: 100 },
  { date: '10/03/2016', 'Number of comments': 76, amount: 100 },
  { date: '10/10/2016', 'Number of comments': 69, amount: 100 },
  { date: '10/17/2016', 'Number of comments': 108, amount: 100 },
  { date: '10/24/2016', 'Number of comments': 106, amount: 100 },
  { date: '10/31/2016', 'Number of comments': 101, amount: 100 },
  { date: '11/07/2016', 'Number of comments': 97, amount: 100 },
  { date: '11/14/2016', 'Number of comments': 88, amount: 100 },
  { date: '11/21/2016', 'Number of comments': 86, amount: 100 },
  { date: '11/28/2016', 'Number of comments': 103, amount: 100 },
  { date: '12/05/2016', 'Number of comments': 95, amount: 100 },
  { date: '12/12/2016', 'Number of comments': 79, amount: 100 },
  { date: '12/19/2016', 'Number of comments': 83, amount: 100 },
  { date: '12/26/2016', 'Number of comments': 70, amount: 100 },
  { date: '01/02/2017', 'Number of comments': 82, amount: 100 },
  { date: '01/09/2017', 'Number of comments': 108, amount: 100 },
  { date: '01/16/2017', 'Number of comments': 115, amount: 100 },
  { date: '01/23/2017', 'Number of comments': 98, amount: 100 },
  { date: '01/30/2017', 'Number of comments': 229, amount: 100 },
  { date: '02/06/2017', 'Number of comments': 111, amount: 100 },
  { date: '02/13/2017', 'Number of comments': 101, amount: 100 },
  { date: '02/20/2017', 'Number of comments': 85, amount: 100 },
  { date: '02/27/2017', 'Number of comments': 105, amount: 100 },
  { date: '03/06/2017', 'Number of comments': 87, amount: 100 },
  { date: '03/13/2017', 'Number of comments': 92, amount: 100 },
  { date: '03/20/2017', 'Number of comments': 90, amount: 100 },
  { date: '03/27/2017', 'Number of comments': 134, amount: 100 },
  { date: '04/03/2017', 'Number of comments': 155, amount: 100 },
  { date: '04/10/2017', 'Number of comments': 153, amount: 100 },
  { date: '04/17/2017', 'Number of comments': 177, amount: 100 },
  { date: '04/24/2017', 'Number of comments': 185, amount: 100 },
  { date: '05/01/2017', 'Number of comments': 138, amount: 100 },
  { date: '05/08/2017', 'Number of comments': 123, amount: 100 },
  { date: '05/15/2017', 'Number of comments': 122, amount: 100 },
  { date: '05/22/2017', 'Number of comments': 122, amount: 100 },
  { date: '05/29/2017', 'Number of comments': 118, amount: 100 },
  { date: '06/05/2017', 'Number of comments': 104, amount: 100 },
  { date: '06/12/2017', 'Number of comments': 96, amount: 100 },
  { date: '06/19/2017', 'Number of comments': 101, amount: 100 },
  { date: '06/26/2017', 'Number of comments': 103, amount: 100 },
  { date: '07/03/2017', 'Number of comments': 124, amount: 100 },
  { date: '07/10/2017', 'Number of comments': 148, amount: 100 },
  { date: '07/17/2017', 'Number of comments': 117, amount: 100 },
  { date: '07/24/2017', 'Number of comments': 113, amount: 100 },
  { date: '07/31/2017', 'Number of comments': 100, amount: 100 },
  { date: '08/07/2017', 'Number of comments': 96, amount: 100 },
  { date: '08/14/2017', 'Number of comments': 94, amount: 100 },
  { date: '08/21/2017', 'Number of comments': 109, amount: 100 },
  { date: '08/28/2017', 'Number of comments': 102, amount: 100 },
  { date: '09/04/2017', 'Number of comments': 90, amount: 100 },
  { date: '09/11/2017', 'Number of comments': 117, amount: 100 },
  { date: '09/18/2017', 'Number of comments': 111, amount: 100 },
  { date: '09/25/2017', 'Number of comments': 104, amount: 100 },
  { date: '10/02/2017', 'Number of comments': 101, amount: 100 },
  { date: '10/09/2017', 'Number of comments': 92, amount: 100 },
  { date: '10/16/2017', 'Number of comments': 105, amount: 100 },
  { date: '10/23/2017', 'Number of comments': 99, amount: 100 },
  { date: '10/30/2017', 'Number of comments': 75, amount: 100 },
  { date: '11/06/2017', 'Number of comments': 67, amount: 100 },
  { date: '11/13/2017', 'Number of comments': 68, amount: 100 },
  { date: '11/20/2017', 'Number of comments': 64, amount: 100 },
  { date: '11/27/2017', 'Number of comments': 70, amount: 100 },
  { date: '12/04/2017', 'Number of comments': 67, amount: 100 },
  { date: '12/11/2017', 'Number of comments': 70, amount: 100 },
  { date: '12/18/2017', 'Number of comments': 54, amount: 100 },
  { date: '12/25/2017', 'Number of comments': 47, amount: 100 },
  { date: '01/01/2018', 'Number of comments': 50, amount: 100 },
  { date: '01/08/2018', 'Number of comments': 78, amount: 100 },
  { date: '01/15/2018', 'Number of comments': 71, amount: 100 },
  { date: '01/22/2018', 'Number of comments': 60, amount: 100 },
  { date: '01/29/2018', 'Number of comments': 58, amount: 100 },
  { date: '02/05/2018', 'Number of comments': 44, amount: 100 },
  { date: '02/12/2018', 'Number of comments': 56, amount: 100 },
  { date: '02/19/2018', 'Number of comments': 38, amount: 100 },
  { date: '02/26/2018', 'Number of comments': 36, amount: 100 },
  { date: '03/05/2018', 'Number of comments': 37, amount: 100 },
  { date: '03/12/2018', 'Number of comments': 45, amount: 100 },
  { date: '03/19/2018', 'Number of comments': 47, amount: 100 },
  { date: '03/26/2018', 'Number of comments': 61, amount: 100 },
  { date: '04/02/2018', 'Number of comments': 77, amount: 100 },
  { date: '04/09/2018', 'Number of comments': 82, amount: 100 },
  { date: '04/16/2018', 'Number of comments': 87, amount: 100 },
  { date: '04/23/2018', 'Number of comments': 91, amount: 100 },
  { date: '04/30/2018', 'Number of comments': 102, amount: 100 },
  { date: '05/07/2018', 'Number of comments': 96, amount: 100 },
  { date: '05/14/2018', 'Number of comments': 97, amount: 100 },
  { date: '05/21/2018', 'Number of comments': 63, amount: 100 },
  { date: '05/28/2018', 'Number of comments': 56, amount: 100 },
  { date: '06/04/2018', 'Number of comments': 63, amount: 100 },
  { date: '06/11/2018', 'Number of comments': 81, amount: 100 },
  { date: '06/18/2018', 'Number of comments': 73, amount: 100 },
  { date: '06/25/2018', 'Number of comments': 60, amount: 100 },
  { date: '07/02/2018', 'Number of comments': 64, amount: 100 },
  { date: '07/09/2018', 'Number of comments': 79, amount: 100 },
  { date: '07/16/2018', 'Number of comments': 100, amount: 100 },
  { date: '07/23/2018', 'Number of comments': 60, amount: 100 },
  { date: '07/30/2018', 'Number of comments': 86, amount: 100 },
  { date: '08/06/2018', 'Number of comments': 99, amount: 100 },
  { date: '08/13/2018', 'Number of comments': 86, amount: 100 },
  { date: '08/20/2018', 'Number of comments': 88, amount: 100 },
  { date: '08/27/2018', 'Number of comments': 81, amount: 100 },
  { date: '09/03/2018', 'Number of comments': 84, amount: 100 },
  { date: '09/10/2018', 'Number of comments': 67, amount: 100 },
  { date: '09/17/2018', 'Number of comments': 72, amount: 100 },
  { date: '09/24/2018', 'Number of comments': 82, amount: 100 },
  { date: '10/01/2018', 'Number of comments': 72, amount: 100 },
  { date: '10/08/2018', 'Number of comments': 73, amount: 100 },
  { date: '10/15/2018', 'Number of comments': 83, amount: 100 },
  { date: '10/22/2018', 'Number of comments': 88, amount: 100 },
  { date: '10/29/2018', 'Number of comments': 71, amount: 100 },
  { date: '11/05/2018', 'Number of comments': 73, amount: 100 },
  { date: '11/12/2018', 'Number of comments': 105, amount: 100 },
  { date: '11/19/2018', 'Number of comments': 50, amount: 100 },
  { date: '11/26/2018', 'Number of comments': 82, amount: 100 },
  { date: '12/03/2018', 'Number of comments': 74, amount: 100 },
  { date: '12/10/2018', 'Number of comments': 54, amount: 100 },
  { date: '12/17/2018', 'Number of comments': 78, amount: 100 },
  { date: '12/24/2018', 'Number of comments': 78, amount: 100 },
  { date: '12/31/2018', 'Number of comments': 69, amount: 100 },
  { date: '01/07/2019', 'Number of comments': 102, amount: 100 },
  { date: '01/14/2019', 'Number of comments': 108, amount: 100 },
  { date: '01/21/2019', 'Number of comments': 125, amount: 100 },
  { date: '01/28/2019', 'Number of comments': 114, amount: 100 },
  { date: '02/04/2019', 'Number of comments': 128, amount: 100 },
  { date: '02/11/2019', 'Number of comments': 94, amount: 100 },
  { date: '02/18/2019', 'Number of comments': 96, amount: 100 },
  { date: '02/25/2019', 'Number of comments': 105, amount: 100 },
  { date: '03/04/2019', 'Number of comments': 96, amount: 100 },
  { date: '03/11/2019', 'Number of comments': 83, amount: 100 },
  { date: '03/18/2019', 'Number of comments': 71, amount: 100 },
  { date: '03/25/2019', 'Number of comments': 110, amount: 100 },
  { date: '04/01/2019', 'Number of comments': 154, amount: 100 },
  { date: '04/08/2019', 'Number of comments': 160, amount: 100 },
  { date: '04/15/2019', 'Number of comments': 159, amount: 100 },
  { date: '04/22/2019', 'Number of comments': 166, amount: 100 },
  { date: '04/29/2019', 'Number of comments': 177, amount: 100 },
  { date: '05/06/2019', 'Number of comments': 159, amount: 100 },
  { date: '05/13/2019', 'Number of comments': 171, amount: 100 },
  { date: '05/20/2019', 'Number of comments': 179, amount: 100 },
  { date: '05/27/2019', 'Number of comments': 119, amount: 100 },
  { date: '06/03/2019', 'Number of comments': 96, amount: 100 },
  { date: '06/10/2019', 'Number of comments': 99, amount: 100 },
  { date: '06/17/2019', 'Number of comments': 146, amount: 100 },
  { date: '06/24/2019', 'Number of comments': 169, amount: 100 },
  { date: '07/01/2019', 'Number of comments': 119, amount: 100 },
  { date: '07/08/2019', 'Number of comments': 145, amount: 100 },
  { date: '07/15/2019', 'Number of comments': 121, amount: 100 },
  { date: '07/22/2019', 'Number of comments': 236, amount: 100 },
  { date: '07/29/2019', 'Number of comments': 150, amount: 100 },
  { date: '08/05/2019', 'Number of comments': 160, amount: 100 },
  { date: '08/12/2019', 'Number of comments': 180, amount: 100 },
  { date: '08/19/2019', 'Number of comments': 217, amount: 100 },
  { date: '08/26/2019', 'Number of comments': 240, amount: 100 },
  { date: '09/02/2019', 'Number of comments': 170, amount: 100 },
  { date: '09/09/2019', 'Number of comments': 161, amount: 100 },
  { date: '09/16/2019', 'Number of comments': 173, amount: 100 },
  { date: '09/23/2019', 'Number of comments': 184, amount: 100 },
  { date: '09/30/2019', 'Number of comments': 163, amount: 100 },
  { date: '10/07/2019', 'Number of comments': 230, amount: 100 },
  { date: '10/14/2019', 'Number of comments': 220, amount: 100 },
  { date: '10/21/2019', 'Number of comments': 212, amount: 100 },
  { date: '10/28/2019', 'Number of comments': 251, amount: 100 },
  { date: '11/04/2019', 'Number of comments': 236, amount: 100 },
  { date: '11/11/2019', 'Number of comments': 186, amount: 100 },
  { date: '11/18/2019', 'Number of comments': 164, amount: 100 },
  { date: '11/25/2019', 'Number of comments': 132, amount: 100 },
  { date: '12/02/2019', 'Number of comments': 200, amount: 100 },
  { date: '12/09/2019', 'Number of comments': 170, amount: 100 },
  { date: '12/16/2019', 'Number of comments': 231, amount: 100 },
  { date: '12/23/2019', 'Number of comments': 197, amount: 100 },
  { date: '12/30/2019', 'Number of comments': 148, amount: 100 },
  { date: '01/06/2020', 'Number of comments': 165, amount: 100 },
  { date: '01/13/2020', 'Number of comments': 192, amount: 100 },
  { date: '01/20/2020', 'Number of comments': 230, amount: 100 },
  { date: '01/27/2020', 'Number of comments': 175, amount: 100 },
  { date: '02/03/2020', 'Number of comments': 173, amount: 100 },
  { date: '02/10/2020', 'Number of comments': 163, amount: 100 },
  { date: '02/17/2020', 'Number of comments': 179, amount: 100 },
  { date: '02/24/2020', 'Number of comments': 152, amount: 100 },
  { date: '03/02/2020', 'Number of comments': 236, amount: 100 },
  { date: '03/09/2020', 'Number of comments': 304, amount: 100 },
  { date: '03/16/2020', 'Number of comments': 255, amount: 100 },
  { date: '03/23/2020', 'Number of comments': 335, amount: 100 },
  { date: '03/30/2020', 'Number of comments': 357, amount: 100 },
  { date: '04/06/2020', 'Number of comments': 274, amount: 100 },
  { date: '04/13/2020', 'Number of comments': 341, amount: 100 },
  { date: '04/20/2020', 'Number of comments': 398, amount: 100 },
  { date: '04/27/2020', 'Number of comments': 438, amount: 100 },
  { date: '05/04/2020', 'Number of comments': 315, amount: 100 },
  { date: '05/11/2020', 'Number of comments': 313, amount: 100 },
  { date: '05/18/2020', 'Number of comments': 296, amount: 100 },
  { date: '05/25/2020', 'Number of comments': 305, amount: 100 },
  { date: '06/01/2020', 'Number of comments': 198, amount: 100 },
  { date: '06/08/2020', 'Number of comments': 229, amount: 100 },
  { date: '06/15/2020', 'Number of comments': 388, amount: 100 },
  { date: '06/22/2020', 'Number of comments': 265, amount: 100 },
  { date: '06/29/2020', 'Number of comments': 201, amount: 100 },
  { date: '07/06/2020', 'Number of comments': 377, amount: 100 },
  { date: '07/13/2020', 'Number of comments': 447, amount: 100 },
  { date: '07/20/2020', 'Number of comments': 283, amount: 100 },
  { date: '07/27/2020', 'Number of comments': 216, amount: 100 },
  { date: '08/03/2020', 'Number of comments': 247, amount: 100 },
  { date: '08/10/2020', 'Number of comments': 283, amount: 100 },
  { date: '08/17/2020', 'Number of comments': 353, amount: 100 },
  { date: '08/24/2020', 'Number of comments': 384, amount: 100 },
  { date: '08/31/2020', 'Number of comments': 282, amount: 100 },
  { date: '09/07/2020', 'Number of comments': 205, amount: 100 },
  { date: '09/14/2020', 'Number of comments': 234, amount: 100 },
  { date: '09/21/2020', 'Number of comments': 167, amount: 100 },
  { date: '09/28/2020', 'Number of comments': 282, amount: 100 },
  { date: '10/05/2020', 'Number of comments': 282, amount: 100 },
  { date: '10/12/2020', 'Number of comments': 344, amount: 100 },
  { date: '10/19/2020', 'Number of comments': 350, amount: 100 },
  { date: '10/26/2020', 'Number of comments': 385, amount: 100 },
  { date: '11/02/2020', 'Number of comments': 201, amount: 100 },
  { date: '11/09/2020', 'Number of comments': 291, amount: 100 },
  { date: '11/16/2020', 'Number of comments': 367, amount: 100 },
  { date: '11/23/2020', 'Number of comments': 273, amount: 100 },
  { date: '11/30/2020', 'Number of comments': 405, amount: 100 },
  { date: '12/07/2020', 'Number of comments': 299, amount: 100 },
  { date: '12/14/2020', 'Number of comments': 416, amount: 100 },
  { date: '12/21/2020', 'Number of comments': 361, amount: 100 },
  { date: '12/28/2020', 'Number of comments': 272, amount: 100 },
  { date: '01/04/2021', 'Number of comments': 323, amount: 100 },
  { date: '01/11/2021', 'Number of comments': 410, amount: 100 },
  { date: '01/18/2021', 'Number of comments': 484, amount: 100 },
  { date: '01/25/2021', 'Number of comments': 362, amount: 100 },
  { date: '02/01/2021', 'Number of comments': 241, amount: 100 },
  { date: '02/08/2021', 'Number of comments': 350, amount: 100 },
  { date: '02/15/2021', 'Number of comments': 291, amount: 100 },
  { date: '02/22/2021', 'Number of comments': 299, amount: 100 },
  { date: '03/01/2021', 'Number of comments': 153, amount: 100 },
  { date: '03/08/2021', 'Number of comments': 335, amount: 100 },
  { date: '03/15/2021', 'Number of comments': 136, amount: 100 },
  { date: '03/22/2021', 'Number of comments': 88, amount: 100 },
  { date: '03/29/2021', 'Number of comments': 468, amount: 100 },
  { date: '04/05/2021', 'Number of comments': 368, amount: 100 },
  { date: '04/12/2021', 'Number of comments': 492, amount: 100 },
  { date: '04/19/2021', 'Number of comments': 665, amount: 100 },
  { date: '04/26/2021', 'Number of comments': 920, amount: 100 },
  { date: '05/03/2021', 'Number of comments': 492, amount: 100 },
  { date: '05/10/2021', 'Number of comments': 554, amount: 100 },
  { date: '05/17/2021', 'Number of comments': 536, amount: 100 },
  { date: '05/24/2021', 'Number of comments': 420, amount: 100 },
  { date: '05/31/2021', 'Number of comments': 307, amount: 100 },
  { date: '06/07/2021', 'Number of comments': 382, amount: 100 },
  { date: '06/14/2021', 'Number of comments': 442, amount: 100 },
  { date: '06/21/2021', 'Number of comments': 384, amount: 100 },
  { date: '06/28/2021', 'Number of comments': 305, amount: 100 },
  { date: '07/05/2021', 'Number of comments': 329, amount: 100 },
  { date: '07/12/2021', 'Number of comments': 570, amount: 100 },
  { date: '07/19/2021', 'Number of comments': 361, amount: 100 },
  { date: '07/26/2021', 'Number of comments': 339, amount: 100 },
  { date: '08/02/2021', 'Number of comments': 435, amount: 100 },
  { date: '08/09/2021', 'Number of comments': 412, amount: 100 },
  { date: '08/16/2021', 'Number of comments': 612, amount: 100 },
  { date: '08/23/2021', 'Number of comments': 750, amount: 100 },
  { date: '08/30/2021', 'Number of comments': 611, amount: 100 },
  { date: '09/06/2021', 'Number of comments': 427, amount: 100 },
  { date: '09/13/2021', 'Number of comments': 450, amount: 100 },
  { date: '09/20/2021', 'Number of comments': 483, amount: 100 },
  { date: '09/27/2021', 'Number of comments': 380, amount: 100 },
  { date: '10/04/2021', 'Number of comments': 349, amount: 100 },
  { date: '10/11/2021', 'Number of comments': 446, amount: 100 },
  { date: '10/18/2021', 'Number of comments': 457, amount: 100 },
  { date: '10/25/2021', 'Number of comments': 403, amount: 100 },
  { date: '11/01/2021', 'Number of comments': 351, amount: 100 },
  { date: '11/08/2021', 'Number of comments': 315, amount: 100 },
  { date: '11/15/2021', 'Number of comments': 357, amount: 100 },
  { date: '11/22/2021', 'Number of comments': 237, amount: 100 },
  { date: '11/29/2021', 'Number of comments': 341, amount: 100 },
  { date: '12/06/2021', 'Number of comments': 419, amount: 100 },
  { date: '12/13/2021', 'Number of comments': 405, amount: 100 },
  { date: '12/20/2021', 'Number of comments': 341, amount: 100 },
  { date: '12/27/2021', 'Number of comments': 249, amount: 100 },
  { date: '01/03/2022', 'Number of comments': 401, amount: 100 },
  { date: '01/10/2022', 'Number of comments': 414, amount: 100 },
  { date: '01/17/2022', 'Number of comments': 551, amount: 100 },
  { date: '01/24/2022', 'Number of comments': 442, amount: 100 },
  { date: '01/31/2022', 'Number of comments': 437, amount: 100 },
  { date: '02/07/2022', 'Number of comments': 393, amount: 100 },
  { date: '02/14/2022', 'Number of comments': 346, amount: 100 },
  { date: '02/21/2022', 'Number of comments': 294, amount: 100 },
  { date: '02/28/2022', 'Number of comments': 219, amount: 100 },
  { date: '03/07/2022', 'Number of comments': 371, amount: 100 },
  { date: '03/14/2022', 'Number of comments': 375, amount: 100 },
  { date: '03/21/2022', 'Number of comments': 423, amount: 100 },
  { date: '03/28/2022', 'Number of comments': 554, amount: 100 },
  { date: '04/04/2022', 'Number of comments': 508, amount: 100 },
  { date: '04/11/2022', 'Number of comments': 569, amount: 100 },
  { date: '04/18/2022', 'Number of comments': 768, amount: 100 },
  { date: '04/25/2022', 'Number of comments': 772, amount: 100 },
  { date: '05/02/2022', 'Number of comments': 581, amount: 100 },
  { date: '05/09/2022', 'Number of comments': 810, amount: 100 },
  { date: '05/16/2022', 'Number of comments': 508, amount: 100 },
  { date: '05/23/2022', 'Number of comments': 414, amount: 100 },
  { date: '05/30/2022', 'Number of comments': 316, amount: 100 },
  { date: '06/06/2022', 'Number of comments': 313, amount: 100 },
  { date: '06/13/2022', 'Number of comments': 394, amount: 100 },
  { date: '06/20/2022', 'Number of comments': 326, amount: 100 },
  { date: '06/27/2022', 'Number of comments': 311, amount: 100 },
  { date: '07/04/2022', 'Number of comments': 364, amount: 100 },
  { date: '07/11/2022', 'Number of comments': 603, amount: 100 },
  { date: '07/18/2022', 'Number of comments': 82, amount: 100 },
];

export default data;
